<template>
    <LayoutDefault>
        <div
            class="container"
            id="home"
        >
            <HomeBannerHeader />

            <div class="content">
                <section class="popular-models">
                    <router-link
                        class="more more-header"
                        :to="{name: 'webstars.index'}"
                    >
                        {{$t('home2021.outstanding')}}
                    </router-link>

                    <template v-if="!loadingModels && !errorModels">
                        <div v-if="models" class="models">
                            <ModelBox
                                class="model"
                                v-for="model in models"
                                :model="model"
                                :key="model.id"
                            />
                        </div>
                        <template v-else>
                            <div class="no-data">
                                {{$t('noRecords')}}
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <Spinner v-if="loadingModels"/>
                        <template v-if="errorModels">
                            <p>
                                {{$t('error')}}
                            </p>
                            <button
                                type="button"
                                @click="loadModels"
                            >
                                {{$t('retry')}}
                            </button>
                        </template>
                    </template>

                    <router-link
                        class="more more-footer"
                        :to="{name: 'webstars.index'}"
                    >
                        {{$t('home2021.more_webstars')}}
                    </router-link>
                </section>
            </div>

            <HomeBannerFooter />

            <BannerSuscribe />
        </div>
    </LayoutDefault>
</template>

<script>
import resources from '../resources';
import Spinner from "../components/Spinner";
import EventBus from '../eventbus';
import LayoutDefault from "../layouts/LayoutDefault2021";
import HomeBannerHeader from "../components/Home/HomeBannerHeader";
import HomeBannerFooter from "../components/Home/HomeBannerFooter";
import ModelBox from '../components/Home/ModelBox';
import BannerSuscribe from "../components/Home/BannerSuscribe";

export default {
    components: {
        BannerSuscribe,
        HomeBannerHeader,
        HomeBannerFooter,
        LayoutDefault,
        Spinner,
        ModelBox,
    },
    data(){
        return {
            loadingModels: true,
            errorModels: false,
            models: null,
        }
    },
    methods: {
        loadModels(){
            this.loadingModels = true;
            this.errorModels = false;
            this.models = null;
            this.modelsCurrentPage = null;

            resources.homepageModels.index({per_page: 36, priority: 1, page: 1, webstars: true, outstanding: true})
                .then((response) => {
                    this.errorModels = false;
                    this.loadingModels = false;
                    this.models = response.data.data;
                }).catch(() => {
                this.loadingModels = false;
                this.errorModels = true;
            });
        },
    },
    computed:{
    },
    mounted(){
        this.loadModels();

        EventBus.$on('languageChanged', () => {
            // this.loadHomepageMovieCategories();
        });
    },
    beforeDestroy(){
    }
}
</script>

<style scoped lang="scss">
@import '../styles/variables';

section {
    text-align: left;
}

#home{
    background-color: #000000;
    min-height: 500px;

    .error{
        text-align: center;
    }

    .content{
        padding: 9px;
        .popular-models {
            .models{
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                .model{
                    //width: 250px;
                }
            }
            .more{
                display: block;
                border: 2px solid #ff0000;
                line-height: 1.5;
                color: #ff0000;
                text-align: center;
                font-size: 1.7em;
                margin: 15px 0;
                font-family: Arial;
                border-radius: 30px;
                transition: 200ms;
                text-transform: uppercase;
                &:hover{
                    background: #ff0000;
                    color: #ffffff;
                }
                &.more-footer{
                    width: 300px;
                    line-height: 2;
                    @media(max-width: 960px){
                        margin: 15px auto;
                    }
                }
            }
        }
    }
}
</style>